// images
import gettak_logo from "../assets/header/gettak-logo.png";
import apple_store from "../assets/footer/apple-store.png";
import google_store from "../assets/footer/google-store.png";
import { UserConsumer } from "../hooks/context/UserContext";

// mui
import Container from "@mui/material/Container";
import Toolbar from "@mui/material/Toolbar";

// mui icons
import LocationOnIcon from "@mui/icons-material/LocationOn";
import EmailIcon from "@mui/icons-material/Email";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";

// translate
import { useTranslation } from "react-i18next";

// router
import { Link } from "react-router-dom";

const Footer = () => {
  const { t } = useTranslation();
  const {userData, theme} = UserConsumer()

  return (
    <footer
      className="!bg-white !text-black border-t border-gray-200 mt-10"
    >
      <Container maxWidth="xl">
        <Toolbar className="!flex-col !items-start md:!items-center pb-5 gap-5" disableGutters>
            {/* --- Top Section (Logo + Contact Info) --- */}
            <div className="w-full grid gap-6 sm:gap-8 grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
                <div className="flex justify-center sm:justify-start">
                    <img
                        className="w-[120px] h-auto object-contain"
                        src={gettak_logo}
                        alt="Gettak logo"
                    />
                </div>
                <div className="flex items-center sm:items-center gap-3">
                    <div className={`${theme === "client" ? "bg-customerColor" : "bg-paretnerColor"} p-2 rounded-full`}>
                        <LocationOnIcon className="text-white" />
                    </div>
                    <div>
                        <p className="font-[600]">{t("address")}</p>
                        <p className="text-sm text-gray-600">{t("address_info")}</p>
                    </div>
                </div>
                <div className="flex items-center sm:items-center gap-3">
                    <div className={`${theme === "client" ? "bg-customerColor" : "bg-paretnerColor"} p-2 rounded-full`}>
                        <EmailIcon className="text-white" />
                    </div>
                    <div>
                        <p className="font-[600]">{t("email")}</p>
                        <p className="text-sm text-gray-600">example@domain.com</p>
                    </div>
                </div>
                <div className="flex items-center sm:items-center gap-3">
                    <div className={`${theme === "client" ? "bg-customerColor" : "bg-paretnerColor"} p-2 rounded-full`}>
                        <LocalPhoneIcon className="text-white" />
                    </div>
                    <div>
                        <p className="font-[600]">{t("phone")}</p>
                        <p className="text-sm text-gray-600">+963987456321</p>
                    </div>
                </div>
            </div>

            {/* --- Bottom Section (Links + Social + App download) --- */}
            <div className="w-full grid gap-8 sm:gap-10 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 border-t border-gray-200 pt-8">
                <div>
                    <p className="text-gray-600">{t("text_footer")}</p>
                    <div className="flex gap-4 mt-4 justify-center lg:justify-start">
                        <div className={`${theme === "client" ? "!bg-customerColor" : "!bg-paretnerColor"} p-2 rounded-full cursor-pointer hover:opacity-80 transition`}>
                        <FacebookIcon className="text-white" />
                        </div>
                        <div className={`${theme === "client" ? "!bg-customerColor" : "!bg-paretnerColor"} p-2 rounded-full cursor-pointer hover:opacity-80 transition`}>
                        <InstagramIcon className="text-white" />
                        </div>
                        <div className={`${theme === "client" ? "!bg-customerColor" : "!bg-paretnerColor"} p-2 rounded-full cursor-pointer hover:opacity-80 transition`}>
                        <YouTubeIcon className="text-white" />
                        </div>
                    </div>
                </div>
                {/* Quick Links */}
                <div className="flex flex-col items-start sm:items-center lg:items-start m-auto">
                    <p className="font-bold mb-3 max-sm:m-auto">{t("links")}</p>
                    <div className="flex flex-col gap-1 max-lg:items-center text-sm text-gray-600">
                        <Link to="client" className={`${theme === "client" ? "hover:text-customerColor" : "hover:text-paretnerColor"} transition`}>
                        {t("home")}
                        </Link>
                        <Link to="client/about" className={`${theme === "client" ? "hover:text-customerColor" : "hover:text-paretnerColor"} transition`}>
                        {t("about")}
                        </Link>
                        <Link to="client/contact" className={`${theme === "client" ? "hover:text-customerColor" : "hover:text-paretnerColor"} transition`}>
                        {t("contact")}
                        </Link>
                        <Link to="client/privacy_policy" className={`${theme === "client" ? "hover:text-customerColor" : "hover:text-paretnerColor"} transition`}>
                        {t("privacy_policy")}
                        </Link>
                    </div>
                </div>
                {/* Download App */}
                <div className="flex flex-col items-center lg:items-start m-auto">
                    <p className="font-[700] mb-3">{t("download_app")}</p>
                    <div className={`flex items-center gap-2 ${theme === "client" ? "!bg-customerColor" : "!bg-paretnerColor"} text-white rounded-lg p-2 w-[150px] hover:opacity-90 transition`}>
                        <img src={apple_store} alt="Apple store" className="w-8 h-8" />
                        <div>
                        <p className="text-xs">{t("download_from")}</p>
                        <p className="font-[600] text-sm">{t("app_store")}</p>
                        </div>
                    </div>
                    <div className={`flex items-center gap-2 ${theme === "client" ? "!bg-customerColor" : "!bg-paretnerColor"} text-white rounded-lg p-2 w-[150px] mt-2 hover:opacity-90 transition`}>
                        <img src={google_store} alt="Google play" className="w-8 h-8" />
                        <div>
                        <p className="text-xs">{t("download_from")}</p>
                        <p className="font-[600] text-sm">{t("google_play")}</p>
                        </div>
                    </div>
                </div>
            </div>
            
            {/* Copyright */}
            <div className="w-full border-t border-gray-200 text-center text-xs text-gray-500 pt-5">
                <a href="https://aigate.me/" target="_blank">
                    {t("copyright")} © {new Date().getFullYear()}  | {t("rights_reserved")}
                </a>
            </div>
        </Toolbar>
      </Container>
    </footer>
  );
};

export default Footer;
